import { createContext } from 'react';
import { OutboundCallProps } from '@api/hooks/useOutboundCall';
import { OutboundCallDetails } from '../types';

export interface OutboundCallModalContextType {
  callToDetails: OutboundCallDetails;
  callFromDetails: OutboundCallDetails;
  setCallToDetails: React.Dispatch<React.SetStateAction<OutboundCallDetails>>;
  setCallFromDetails: React.Dispatch<React.SetStateAction<OutboundCallDetails>>;
  callButtonEnabled: boolean;
  phoneConnected: boolean;
  outboundCallsAllowed: boolean;
  from: {
    name: string;
    number: string;
  };
  to: {
    name: string;
    number: string;
  };
  outboundCall: (props: OutboundCallProps) => Promise<void>;
  isProcessingCall: boolean;
}

export const OutboundCallModalContext =
  createContext<OutboundCallModalContextType>(
    {} as OutboundCallModalContextType,
  );
